import { EntityApiService } from '@dofleini/security';

import { authentication } from '@/settings';

class ActorApiService extends EntityApiService {

}

export default new ActorApiService(`${authentication.path}/api/actors`);
